import { useEffect, useMemo, useState } from 'react'

import { addToast } from 'components/Toast/Toast'

import { postIdOf, variantKeyOf } from '../vault.helpers'

export function useVaultSelection(postsGrouped: string | boolean) {
const [selectedPosts, setSelecetedPosts] = useState<string[]>([])
const [postIds, setPostIds] = useState<string[]>([])
  const [allSelectedMedia, setAllSelectedMedia] = useState<any[]>([])
  const [selectedVariantKeys, setSelectedVariantKeys] = useState<string[]>([])
  const [allMediaLength, setAllMediaLength] = useState<number>(0)

  const isGrouped = useMemo(() => {
    return typeof postsGrouped === 'string'
      ? postsGrouped.toLowerCase() === 'true'
      : Boolean(postsGrouped)
  }, [postsGrouped])

  // clear variant keys when switching modes (same behavior)
  useEffect(() => {
    if (postsGrouped) setSelectedVariantKeys([])
  }, [postsGrouped])

  const recomputeGroupSelectionFromList = (list: any[]) => {
    const groupIds = new Set<string>()
    const postIdsSet = new Set<string>()

    for (const it of list) {
      const groupId = it.parent_id ?? it.id

      if (typeof groupId === 'string') {
        groupIds.add(groupId)
      }

      const pid = postIdOf(it)

      if (typeof pid === 'string') {
        postIdsSet.add(pid)
      }
    }

    setSelecetedPosts(Array.from(groupIds))
    setPostIds(Array.from(postIdsSet))
    setAllMediaLength(list.length)
  }

  const toggleVariantSelection = (variant: any) => {
    const key = variantKeyOf(variant)
    if (!key) return

    setSelectedVariantKeys(prev => {
      const exists = prev.includes(key)

      if (exists) {
        const nextKeys = prev.filter(k => k !== key)
        const nextMedia = allSelectedMedia.filter((it: any) => variantKeyOf(it) !== key)
        setAllSelectedMedia(nextMedia)
        recomputeGroupSelectionFromList(nextMedia)
        return nextKeys
      }

      if (prev.length >= 40) {
        addToast('error', 'Only 40 media files can be selected at once')
        return prev
      }

      const nextKeys = [...prev, key]
      const nextMedia = [...allSelectedMedia, variant]
      setAllSelectedMedia(nextMedia)
      recomputeGroupSelectionFromList(nextMedia)
      return nextKeys
    })
  }

  // ---- YOUR ORIGINAL toggleSelectedPosts LOGIC (unchanged)
const toggleSelectedPosts = (val: any) => {
  const getMediaCount = (item: any): number => {
    if (item.post) {
      return (
        (item.post.videos?.length ?? 0) +
        (item.post.photos?.length ?? 0)
      )
    }

    if (item.message?.message) {
      return (
        (item.message.message.videos?.length ?? 0) +
        (item.message.message.photos?.length ?? 0)
      )
    }

    if (item.story) {
      return 1
    }

    return 0
  }

  const isSelected = allSelectedMedia.some(
    (item: any) => item.id === val.id
  )

  let nextMedia: any[]

  if (isSelected) {
    nextMedia = allSelectedMedia.filter(
      (item: any) => item.id !== val.id
    )
  } else {
    const currentCount = allSelectedMedia.reduce(
      (total: number, item: any) =>
        total + getMediaCount(item),
      0
    )

    const addedCount = getMediaCount(val)

    if (currentCount + addedCount > 40) {
      addToast('error', 'Only 40 media files can be selected at once')
      return
    }

    nextMedia = [...allSelectedMedia, val]
  }

  setAllSelectedMedia(nextMedia)

  // Rebuild selection IDs from the actual selected media.
  recomputeGroupSelectionFromList(nextMedia)

  // Preserve the original media-count behavior.
  setAllMediaLength(
    nextMedia.reduce(
      (total: number, item: any) =>
        total + getMediaCount(item),
      0
    )
  )
}

  return {
    isGrouped,
    selectedPosts,
    setSelecetedPosts,
    postIds,
    setPostIds,
    allSelectedMedia,
    setAllSelectedMedia,
    selectedVariantKeys,
    setSelectedVariantKeys,
    allMediaLength,
    setAllMediaLength,
    toggleVariantSelection,
    toggleSelectedPosts,
  }
}
